(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-gift-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-gift-picker')) {
    customElements.define(
      'cart-gift-picker',
      class CartGiftPicker extends HTMLElement {
        connectedCallback() {
          this.onClick = this.onClick.bind(this);
          this.onChange = this.onChange.bind(this);
          this.addEventListener('click', this.onClick);
          this.addEventListener('change', this.onChange);
          this.pruneIfNeeded();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('change', this.onChange);
        }

        cartRoot() {
          return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        }

        giftKeys() {
          return (this.dataset.giftKeys || '')
            .split(',')
            .map((key) => key.trim())
            .filter(Boolean);
        }

        async pruneIfNeeded() {
          const keys = (this.dataset.pruneKeys || '')
            .split(',')
            .map((key) => key.trim())
            .filter(Boolean);
          if (!keys.length || this.dataset.pruning === 'true') return;
          this.dataset.pruning = 'true';
          try {
            await this.updateQuantities(keys);
            await this.refresh();
          } catch (error) {
            console.error(error);
          }
        }

        onClick(event) {
          const button = event.target.closest('[data-gift-select]');
          const card = event.target.closest('[data-gift-card]');
          if (!card || this.classList.contains('is-busy')) return;
          if (!button && event.target.closest('select, button, a, label')) return;
          event.preventDefault();
          this.selectCard(card);
        }

        onChange(event) {
          const select = event.target.closest('[data-gift-option]');
          if (!select) return;
          event.stopPropagation();
          event.stopImmediatePropagation();
          const card = select.closest('[data-gift-card]');
          if (!card) return;
          this.syncCardPreview(card);
          if (card.dataset.selected === 'true' && this.variantIdFrom(card)) {
            this.selectCard(card, true);
          }
        }

        syncCardPreview(card) {
          const select = card.querySelector('select[data-gift-option]');
          const variant = this.variantFrom(card);
          if (!variant) return;
          const image = card.querySelector('[data-gift-image]');
          if (image && variant.image) image.src = variant.image;
          const meta = card.querySelector('[data-gift-meta]');
          const optionIndex = Number(card.dataset.optionIndex);
          if (meta && Array.isArray(variant.options)) {
            const other = variant.options.filter((_, index) => index !== optionIndex);
            if (other.length) meta.textContent = other.join(' · ');
          }
        }

        variantsFrom(card) {
          const script = card.querySelector('[data-gift-variants]');
          if (!script) return [];
          try {
            return JSON.parse(script.textContent);
          } catch (error) {
            return [];
          }
        }

        variantFrom(card) {
          const variants = this.variantsFrom(card);
          const variantId = this.variantIdFrom(card);
          return variants.find((variant) => String(variant.id) === String(variantId));
        }

        variantIdFrom(card) {
          const hidden = card.querySelector('input[data-gift-option]');
          if (hidden) return hidden.dataset.variantId || hidden.value;
          const select = card.querySelector('select[data-gift-option]');
          if (!select || !select.value) return '';
          const optionIndex = Number(card.dataset.optionIndex);
          const variants = this.variantsFrom(card);
          const matches = variants.filter((variant) => String(variant.options?.[optionIndex]) === select.value);
          if (matches.length === 1) return String(matches[0].id);
          const meta = (card.querySelector('[data-gift-meta]')?.textContent || '').toLowerCase();
          const preferred = matches.find((variant) =>
            (variant.options || []).some((option, index) => index !== optionIndex && meta.includes(String(option).toLowerCase()))
          );
          return String((preferred || matches[0] || {}).id || '');
        }

        async selectCard(card, force) {
          const variantId = this.variantIdFrom(card);
          const select = card.querySelector('select[data-gift-option]');
          const sameVariant = !select || String(select.dataset.currentVariant || '') === String(variantId);
          const deselect = !force && card.dataset.selected === 'true' && sameVariant;

          if (!deselect && !variantId) {
            select?.focus();
            return;
          }

          this.classList.add('is-busy');
          card.classList.add('is-busy');
          try {
            const keys = this.giftKeys();
            if (keys.length) await this.updateQuantities(keys);
            if (!deselect) await this.addGift(variantId);
            await this.refresh();
          } catch (error) {
            console.error(error);
            this.classList.remove('is-busy');
            card.classList.remove('is-busy');
          }
        }

        updateQuantities(keys) {
          const updates = {};
          keys.forEach((key) => {
            updates[key] = 0;
          });
          return fetch(`${this.cartRoot()}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          }).then((response) => {
            if (!response.ok) throw new Error('gift update failed');
            return response.json();
          });
        }

        addGift(variantId) {
          return fetch(`${this.cartRoot()}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                  properties: { _gwp: 'true', _benlee_gift: '1' },
                },
              ],
            }),
          }).then((response) => {
            if (!response.ok) throw new Error('gift add failed');
            return response.json();
          });
        }

        refresh() {
          if (typeof window.blRefreshCartDrawer === 'function') {
            return window.blRefreshCartDrawer(false);
          }
          return Promise.resolve();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-progress-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-progress-bar')) {
    customElements.define('cart-progress-bar', class CartProgressBar extends HTMLElement {});
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judgeme-amazon-source"] && !Shopify.designMode) return;
  try {
    if (!window.__blJdgmAmazonSourceInit) {
    window.__blJdgmAmazonSourceInit = true;

    const NATIVE_SOURCES = ['shopify', 'shop-app', 'web', 'store'];

    const getLabel = () => {
      const holder = document.querySelector('[data-bl-jdgm-amazon-source]');
      const text = holder?.getAttribute('data-label')?.trim();
      return text ? ` · ${text}` : '';
    };

    const collectWidgetReviews = () => {
      const widgets = window.jdgm?.data?.reviewWidget;
      const reviews = [];
      if (!widgets) return reviews;

      for (const widget of Object.values(widgets)) {
        if (!Array.isArray(widget?.reviews)) continue;
        for (const review of widget.reviews) reviews.push(review);
      }

      return reviews;
    };

    const findReviewRecord = (item) => {
      const uuid = item.getAttribute('review-uuid');
      if (!uuid) return null;

      for (const review of collectWidgetReviews()) {
        if (String(review.uuid) === String(uuid)) return review;
      }

      return null;
    };

    const isAmazonImported = (review) => {
      if (!review) return true;

      const source = String(review.source || '').toLowerCase();
      const platform = String(review.platform || '').toLowerCase();
      const badges = Array.isArray(review.transparency_badges)
        ? review.transparency_badges.join(' ').toLowerCase()
        : '';
      const blob = `${source} ${platform} ${badges}`;

      if (blob.includes('amazon')) return true;
      if (NATIVE_SOURCES.includes(source)) return false;
      if (blob.includes('etsy') || blob.includes('google') || blob.includes('shop-app')) return false;

      return true;
    };

    const findMetaText = (item) => {
      const nodes = item.querySelectorAll(
        '.jm-reviewer-info .jm-text:not(.jm-reviewer-info__name):not(.jm-location)'
      );

      let target = null;
      for (const node of nodes) {
        if (node.textContent.trim() === '•') continue;
        target = node;
      }

      return target;
    };

    const labelReview = (item, label) => {
      if (!isAmazonImported(findReviewRecord(item))) return;

      const target = findMetaText(item);
      if (!target) return;
      if (target.textContent.includes(label.trim())) return;

      target.append(label);
    };

    const applyLabels = () => {
      const label = getLabel();
      if (!label) return;

      const items = document.querySelectorAll('.jm-review-item');
      for (const item of items) labelReview(item, label);
    };

    const start = () => {
      applyLabels();

      let timer = 0;
      const observer = new MutationObserver(() => {
        window.clearTimeout(timer);
        timer = window.setTimeout(applyLabels, 50);
      });

      const widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
      observer.observe(widget || document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('promo-code-copy')) {
    class PromoCodeCopy extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.product-promo__code');
        this.status = this.querySelector('[data-promo-status]');
        if (!this.button) return;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        if (this.resetTimer) clearTimeout(this.resetTimer);
      }

      onClick() {
        const code = this.button.dataset.promoCode;
        if (!code) return;
        this.copy(code);
      }

      copy(code) {
        const done = () => this.announce();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(() => {
            this.fallbackCopy(code);
            done();
          });
          return;
        }
        this.fallbackCopy(code);
        done();
      }

      fallbackCopy(code) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'absolute';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }

      announce() {
        this.button.classList.add('is-copied');
        if (this.status) {
          this.status.textContent = this.dataset.success || '';
        }
        if (this.resetTimer) clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.button.classList.remove('is-copied');
          if (this.status) this.status.textContent = '';
        }, 2000);
      }
    }

    customElements.define('promo-code-copy', PromoCodeCopy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart-drawer')) {
    class SizeChartDrawer extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeyup = this.onKeyup.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
      }

      connectedCallback() {
        if (!this.bound) {
          this.bound = true;
          this.addEventListener('click', this.onClick);
          this.addEventListener('keyup', this.onKeyup);
        }

        if (this.moved) return;
        this.moved = true;

        document.querySelectorAll('size-chart-drawer').forEach((node) => {
          if (node !== this && node.id === this.id) node.remove();
        });

        document.body.appendChild(this);
      }

      get dialog() {
        return this.querySelector('[role="dialog"]');
      }

      get closeButton() {
        return this.querySelector('.size-chart-drawer__close');
      }

      get triggers() {
        return document.querySelectorAll(`[data-size-chart-drawer="${this.id}"]`);
      }

      onClick(event) {
        if (event.target.closest('.size-chart-drawer__close')) {
          this.close();
          return;
        }

        if (event.target.closest('.size-chart-drawer__inner')) return;
        this.close();
      }

      onKeyup(event) {
        if (event.code === 'Escape') this.close();
      }

      open(triggeredBy) {
        this.openedBy = triggeredBy;
        this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');

        setTimeout(() => {
          this.classList.add('active');
          document.addEventListener('click', this.onDocumentClick);
          const focusTarget = this.closeButton || this.dialog;
          if (typeof trapFocus === 'function' && this.dialog) {
            trapFocus(this.dialog, focusTarget);
          } else if (focusTarget) {
            focusTarget.focus();
          }
        });
      }

      onDocumentClick(event) {
        if (!this.classList.contains('active') && !this.hasAttribute('open')) return;
        if (event.target.closest('.size-chart-drawer__inner')) return;
        if (event.target.closest('[data-size-chart-drawer]')) return;
        this.close();
      }

      close() {
        this.classList.remove('active');
        this.removeAttribute('open');
        this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('click', this.onDocumentClick);
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.openedBy);
        } else if (this.openedBy) {
          this.openedBy.focus();
        }
      }
    }

    customElements.define('size-chart-drawer', SizeChartDrawer);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-chart-drawer]');
      if (!trigger) return;
      const drawer = document.getElementById(trigger.getAttribute('data-size-chart-drawer'));
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(trigger);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-atc')) {
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.syncFromPrimary = this.syncFromPrimary.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);

        this.primaryButton = document.getElementById(this.dataset.primaryButtonId);
        this.headerEl = document.querySelector('.header-wrapper');
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.scrollTick = false;

        if (this.primaryButton) {
          this.buttonObserver = new MutationObserver(this.syncFromPrimary);
          this.buttonObserver.observe(this.primaryButton, {
            attributes: true,
            attributeFilter: ['disabled', 'class', 'aria-disabled'],
            childList: true,
            subtree: true,
            characterData: true,
          });

          this.syncFromPrimary();
        }

        this.desktopQuery.addEventListener('change', this.onBreakpointChange);
        this.setupScrollVisibility();
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.desktopQuery?.removeEventListener('change', this.onBreakpointChange);
      }

      get submitButton() {
        return this.querySelector('[data-sticky-atc-submit]');
      }

      get desktopThreshold() {
        const rootFontSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
        return Number.isFinite(rootFontSize) ? rootFontSize : 16;
      }

      setupScrollVisibility() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);

        if (!this.desktopQuery.matches) {
          this.classList.remove('is-visible');
          this.removeAttribute('inert');
          this.style.removeProperty('inset-block-start');
          return;
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.updateDesktopVisibility();
      }

      onBreakpointChange() {
        this.setupScrollVisibility();
      }

      onScroll() {
        if (this.scrollTick) return;
        this.scrollTick = true;
        requestAnimationFrame(() => {
          this.scrollTick = false;
          this.updateDesktopVisibility();
        });
      }

      onResize() {
        if (!this.desktopQuery.matches) return;
        this.syncToHeader();
      }

      updateDesktopVisibility() {
        if (!this.desktopQuery.matches) return;

        const visible = window.scrollY >= this.desktopThreshold;
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.syncToHeader();
      }

      syncToHeader() {
        const header = this.headerEl || document.querySelector('.header-wrapper');
        if (!header) return;

        const bottom = header.getBoundingClientRect().bottom;
        this.style.insetBlockStart = `${Math.max(0, Math.floor(bottom))}px`;
      }

      syncFromPrimary() {
        const primary = this.primaryButton;
        const button = this.submitButton;
        if (!primary || !button) return;

        const isDisabled =
          primary.hasAttribute('disabled') || primary.getAttribute('aria-disabled') === 'true';
        button.toggleAttribute('disabled', isDisabled);

        if (isDisabled) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }

        const isLoading = primary.classList.contains('loading');
        button.classList.toggle('loading', isLoading);
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);

        const primaryText = primary.querySelector('.product-form__submit-text');
        const stickyText = button.querySelector('[data-sticky-atc-label]');
        if (primaryText && stickyText) {
          stickyText.textContent = primaryText.textContent.trim();
        }
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
